import * as React from 'react';

import * as styles from './SummaryButtonWrapper.css';

export const SummaryButtonWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['btn-spacer']}>{children}</div>;
};

SummaryButtonWrapper.displayName = 'SummaryButtonWrapper';
